// extracted by mini-css-extract-plugin
export var cardHeader = "_ti-0";
export var reorderHandle = "_ti-3";
export var titleArea = "_ti-1";
export var titleAreaWithHandle = "_ti-2";